import { defineStore } from "pinia"
import { computed, reactive } from "vue"

export const useCustomDeliveryAddressStore = defineStore("custom-delivery-address", () => {
    const newShippingAddress = reactive({
        firstName: "",
        lastName: "",
        street: "",
        city: "",
        zip: "",
        deliveryNote: "",
        additionalAddress: "",
    })

    const addressComplete = computed(() => {
        return !!(
            newShippingAddress.firstName.trim() &&
            newShippingAddress.lastName.trim() &&
            newShippingAddress.street.trim() &&
            newShippingAddress.zip.trim() &&
            newShippingAddress.city.trim()
        )
    })

    function reset() {
        newShippingAddress.firstName = ""
        newShippingAddress.lastName = ""
        newShippingAddress.street = ""
        newShippingAddress.city = ""
        newShippingAddress.zip = ""
        newShippingAddress.deliveryNote = ""
        newShippingAddress.additionalAddress = ""
    }

    return {
        newShippingAddress,
        addressComplete,
        reset,
    }
})
